import requestStatuses from './request-statuses';
export default {
  createStatus: requestStatuses.IDLE,
  readStatus: requestStatuses.IDLE,
  updateStatus: requestStatuses.IDLE,
  deleteStatus: requestStatuses.IDLE
};